<template>
  <base-dialog-form ref="massiveUpgradeEventoDialog" :title="$t('massive_event_upgrade')" color="secondary"
    icon="mdi-arrow-up-circle">
    <v-container>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :step="1" :editable="stepper >= 1" :complete="stepper > 1">{{ $t("select_payment")
          }}</v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :step="2" :editable="stepper >= 2" :complete="stepper > 2">{{ $t("select_options")
          }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-container>
              <select-mod-pag :idEvento="idEvento" :onlyAutoConf="true" @selected="selectedPayment"></select-mod-pag>
            </v-container>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <v-row v-if="RBAC_INSERT_OTHER_USER">
              <v-col cols="12">
                <v-autocomplete v-model="masterId" :items="selectUsers" item-text="text" item-value="value"
                  @change="gotoUser" dense :label="$t('select_user')"></v-autocomplete>
              </v-col>
            </v-row>
            <v-container :v-if="eventData" style="margin-top: 50px" v-for="partecipante in eventData"
              v-bind:key="partecipante.id">
              <base-material-card color="secondary" :id="'user-' + partecipante.id" :avatar="partecipante.avatar">
                <v-row justify="center">
                  <div class="display-1 mt-2 font-weight-light">
                    {{ partecipante.fullName }}
                  </div>
                </v-row>
                <v-row v-for="pacchetto in partecipante.pacchetti" v-bind:key="pacchetto.idPacchetto">
                  <v-col cols="12">
                    <v-card outlined icon="mdi-calendar-check" v-if="pacchetto.canUpgrade">
                      <v-card-title>{{ pacchetto.descr }}</v-card-title>
                      <v-card-text>
                        <v-row class="text-center" v-for="dettaglio in pacchetto.dettagli"
                          v-bind:key="dettaglio.idDettaglio">
                          <v-col md="4" cols="12">
                            <v-radio-group @change="
                              selectOpzione(
                                pacchetto.dettagliScelti,
                                dettaglio
                              )
                            " :error="pacchetto.errorRequired" :disabled="!pacchetto.enabled" :error-messages="
  pacchetto.errorRequired ? $t('required') : null
" v-if="pacchetto.multiscelta === 0" v-model="pacchetto.dettagliScelti[0]">
                              <v-radio :disabled="!dettaglio.enabled" :label="dettaglio.testo"
                                :value="dettaglio.idDettaglio"></v-radio>
                            </v-radio-group>

                            <v-checkbox v-else @change="
                              selectOpzione(
                                pacchetto.dettagliScelti,
                                dettaglio
                              )
                            " :error="pacchetto.errorRequired" :disabled="!dettaglio.enabled" :error-messages="
  pacchetto.errorRequired ? $t('required') : null
" :multiple="
  pacchetto.multiscelta === 0 ? false : true
" v-model="pacchetto.dettagliScelti" :label="dettaglio.testo"
                              :value="dettaglio.idDettaglio"></v-checkbox>
                          </v-col>
                          <v-col md="4" cols="12">
                            <v-select v-if="
                              dettaglio.opzioni &&
                              dettaglio.opzioni.length > 0
                            " :error="dettaglio.errorRequiredOptions" :error-messages="
  dettaglio.errorRequiredOptions
    ? $t('required')
    : null
" v-model="dettaglio.selectedOptions" :items="dettaglio.opzioni" :disabled="
  !dettaglio.enabled ||
  pacchetto.dettagliScelti === undefined ||
  !pacchetto.dettagliScelti.includes(
    dettaglio.idDettaglio
  )
" :menu-props="{ maxHeight: '400' }" :label="$t('options')" color="primary"></v-select>
                          </v-col>
                          <v-col v-if="dettaglio.postiTotali" md="2" cols="6">
                            {{ $t("occupied_places") }}
                            {{ dettaglio.postiOccupati }} /
                            {{ dettaglio.postiTotali }}
                            <br />
                            <br />
                            <v-progress-linear color="primary" :value="
                              (dettaglio.postiOccupati * 100) /
                              dettaglio.postiTotali
                            "></v-progress-linear>
                          </v-col>
                          <v-col md="2" cols="6">
                            <v-text-field v-model="dettaglio.prezzo" :label="$t('price')" :disabled="
                              !dettaglio.enabled ||
                              !RBAC_CAN_CHANGE_PRICE ||
                              pacchetto.dettagliScelti === undefined ||
                              !pacchetto.dettagliScelti.includes(
                                dettaglio.idDettaglio
                              )
                            " type="number" hide-details="auto"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <v-btn color="success" @click="confirmOrder(partecipante.id)" type="submit">{{ $t("confirm")
                    }}</v-btn>
                  </v-col>
                </v-row>
              </base-material-card>
            </v-container>
            <v-container>
              <v-row v-if="eventData.length > 0">
                <v-col cols="12" class="text-center">
                  <v-btn color="success" @click="confirmOrder()" type="submit">{{ $t("confirm") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";
import selectModPag from "@/widget/selectModPag.vue";

export default {
  name: "massive-upgrade-evento",
  components: {
    selectModPag,
  },
  data() {
    return {
      idEvento: null,
      masterId: null,
      stepper: 1,
      eventData: [],
      selectUsers: [],
      opzioniScelte: [],
      pagId: null,
      dataPag: null,
      RBAC_INSERT_OTHER_USER: false,
      RBAC_CAN_CHANGE_PRICE: false,
    };
  },
  created() {
    let _ = this;
    _.masterId = parseInt(window.myData.masterId);
    _.RBAC_INSERT_OTHER_USER = _.checkUserRole("eventi", "INSERT_OTHER_USER");
    _.RBAC_CAN_CHANGE_PRICE = _.checkUserRole("eventi", "CAN_CHANGE_PRICE");
  },
  methods: {
    open(idEvento) {
      this.idEvento = idEvento;
      this.loadData();
      this.$refs.massiveUpgradeEventoDialog.open();
    },
    loadData() {
      let _ = this;
      _.selectUsers = [];
      let url = "/auth/eventi/getOpzioniEvento/" + this.idEvento;
      _.eventData = [];
      _.chiamataAxios("GET", url).then((response) => {
        _.eventData = response.data.partecipanti.filter((item) => {
          if (item.canUpgrade) return true;
        });
        _.selectUsers = _.eventData.map(function (item) {
          return { value: item.masterId, text: item.fullName };
        });
        _.eventData = _.eventData.map(function (partecipante) {
          partecipante.pacchetti = partecipante.pacchetti.map(function (
            pacchetto
          ) {
            pacchetto.dettagli = pacchetto.dettagli.map(function (dettaglio) {
              dettaglio.errorRequiredOptions = false;
              return dettaglio;
            });
            pacchetto.errorRequired = false;
            return pacchetto;
          });
          return partecipante;
        });
      });
    },
    selectOpzione(scelti, dettaglio) {
      if (!dettaglio.selectedOptions)
        dettaglio.selectedOptions = dettaglio.opzioni[0];
      return true;
    },
    gotoUser() {
      let target = "user-" + this.masterId;
      document.getElementById(target).scrollIntoView();
    },
    selectedPayment(pagamento) {
      this.pagId = pagamento.pagId;
      this.dataPag = pagamento.dataPag;
      this.stepper = 2;
    },
    confirmOrder(masterId) {
      let _ = this;
      let aggiornati = [];
      // seleziono dettagli da salvare
      _.eventData = _.eventData.map((eventoUtente) => {
        let error = false;
        _.opzioniScelte = [];
        if (!masterId || eventoUtente.masterId === masterId) {
          // Controllo form
          eventoUtente.pacchetti = eventoUtente.pacchetti.map((pacchetto) => {
            pacchetto.errorRequired = false;
            let scelti = [];
            if (pacchetto.enabled && pacchetto.dettagliScelti !== undefined) {
              scelti = pacchetto.dettagli.map((dettaglio) => {
                if (
                  dettaglio.enabled &&
                  pacchetto.dettagliScelti.includes(dettaglio.idDettaglio)
                )
                  return dettaglio.idDettaglio;
              });
            }
            if (
              pacchetto.required === 1 &&
              pacchetto.dettagliScelti.length === 0
            ) {
              pacchetto.errorRequired = true;
              error = true;
            }
            pacchetto.dettagli = pacchetto.dettagli.map(function (dettaglio) {
              dettaglio.errorRequiredOptions = false;

              if (scelti.includes(dettaglio.idDettaglio)) {
                _.opzioniScelte.push({
                  idPacchetto: pacchetto.idPacchetto,
                  idDettaglio: dettaglio.idDettaglio,
                  selectedOptions: dettaglio.selectedOptions,
                  text: dettaglio.testo,
                  prezzo: dettaglio.prezzo,
                });

                if (
                  !dettaglio.selectedOptions &&
                  dettaglio.opzioni &&
                  dettaglio.opzioni.length > 0
                ) {
                  error = true;
                  dettaglio.errorRequiredOptions = true;
                }
              }
              return dettaglio;
            });
            return pacchetto;
          });
          if (_.opzioniScelte.length === 0) {
            error = true;
          }
          // Se ci sono errori torno evento, così rimane nella videata
          if (error) {
            return eventoUtente;
          } else {
            let data = {
              opzioniScelte: this.opzioniScelte,
              pagId: this.pagId,
              dataPag: this.dataPag,
            };

            let url =
              "/auth/eventi/savePartecipazione/" +
              eventoUtente.id +
              "/" +
              this.idEvento;
            this.chiamataAxios("POST", url, {
              dialogLoader: true,
              msg: "always",
              body: data,
            }).then(() => {
              _.$updateCrediti.updateCreditiRsp.updated = new Date();
            });
            aggiornati.push(eventoUtente.id);
          }
        }
        return eventoUtente;
      });
      Swal.fire({
        title: _.$t("operation_completed"),
        html: _.$t("operation_completed"),
      });

      // Rimuovo utenti modificati
      _.eventData = _.eventData.filter((eventoUtente) => {
        if (aggiornati.includes(eventoUtente.id)) return false;
        else return true;
      });
    },
  },
};
</script>

<style scoped>
.rigaInfo {
  height: auto;
}

.colInfo {
  height: 100%;
}

.locandina {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: auto;
}

.text-evento {
  height: 450px;
  overflow-y: auto;
}
</style>